<template>
  <div class="create-user">

    <div class="columns">
      <div class="column">
        <h2 class="title is-4">New User
          <span class="tag is-info is-clickable" @click="goBack">Back</span>
          <span class="tag is-info is-clickable" @click="test">TEST</span>
        </h2>

        <div v-if="msg.length" class="notification is-info">
          <button class="delete"></button>
          {{ msg }}
        </div>
      </div>
    </div>

    <div v-if="errMsg.length" class="notification is-info">
      <button class="delete"></button>
      <strong>ERROR!</strong> {{ errMsg }}
    </div>

    <user-form @submit-user="submitUser" :loading="loading" :new-user="true" :show-cancel="true" @cancel="goBack"/>

  </div>
</template>

<script>
import UserForm from '../../components/UserForm'
export default {
  name: 'NewUser',
  components: {
    UserForm
  },
  data () {
    return {
      msg: '',
      errMsg: '',
      loading: false
    }
  },
  methods: {
    goBack () {
      this.$router.push({ path: '/admin/users' })
    },
    async submitUser (user) {
      this.msg = ''
      this.loading = true
      try {
        let userData = {
          firstName: user.firstName,
          lastName: user.lastName,
          username: user.username,
          password: user.password,
          email: this.$utils.usernameToEmail(user.username),
          phone: user.phone,
          address: user.address,
          privileges: user.privileges
        }
        const resp = await this.$http.post(`${this.$store.getters.apiUrl}/add-user`, userData)
        this.msg = ''
        if (resp.data.status === 'error') {
          this.$buefy.snackbar.open({
            duration: 5000,
            message: resp.data.msg,
            type: 'is-danger',
            position: 'is-bottom'
          })
        } else {
          this.$toast.open({
            message: 'User added!',
            type: 'is-info'
          })
          this.goBack()
        }
      } catch (err) {
        this.msg = ''
        this.$buefy.snackbar.open({
          duration: 5000,
          message: 'Server not reachable',
          type: 'is-danger',
          position: 'is-bottom'
        })
        console.log('ERROR', err)
      }
      this.loading = false
    },
    test () {
      console.log('tes', this.$buefy.snackbar)
      this.$buefy.snackbar.open({
        duration: 5000,
        message: 'Server not reachable',
        type: 'is-danger',
        position: 'is-bottom'
      })
    }
  }
}
</script>
